import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-common-guidance-card',
    templateUrl: './common-guidance-card.component.html',
    styleUrls: ['./common-guidance-card.component.scss'],
    standalone: false
})
export class CommonGuidanceCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
